const rootElement = document.querySelector('#shopify-section-hb-lp-cycle');

const initCycleObserver = () => {
  if (!rootElement) return;

  const titleSpans = rootElement.querySelectorAll('.js-cycle-title span');
  const items = rootElement.querySelectorAll('.js-cycle-item');

  if (!items.length) return;

  const observerOptions = {
    root: null,
    rootMargin: '-30% 0px -40% 0px', 
    threshold: 0.2
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const index = entry.target.getAttribute('data-index');
        
        titleSpans.forEach(span => {
          span.classList.remove('tw:text-[#FF4D00]');
          span.classList.add('tw:text-[#A3A3A3]');
        });

        const activeSpan = rootElement.querySelector(`.js-cycle-title span[data-index="${index}"]`);
        if (activeSpan) {
          activeSpan.classList.remove('tw:text-[#A3A3A3]');
          activeSpan.classList.add('tw:text-[#FF4D00]');
        }
      }
    });
  }, observerOptions);

  items.forEach(item => observer.observe(item));
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCycleObserver);
} else {
  initCycleObserver();
}

document.addEventListener('shopify:section:load', (event) => {
  if (event.detail.sectionId === 'hb-lp-cycle' || event.target.id === 'shopify-section-hb-lp-cycle') {
    initCycleObserver();
  }
});
